import { FC } from "react";
import style from "./tabsWithIcons.module.css";
import Font from "../Typography/Font";

export type TabWithIconPanelProps = {
  title: string;
  icon?: JSX.Element;
  children?: any;
  name?: string;
  className?: string;
  selected?: boolean;
  onClick?: () => void;
  width?: string;
};
const TabWithIconPanel: FC<TabWithIconPanelProps> = ({
  title,
  icon,
  name,
  selected = false,
  onClick,
  width,
}) => {
  return (
    <div
      true-element={`true-element-tab-element-${name}`}
      className={`${style.tab_button} ${selected ? style.active_tab : ""}`}
      onClick={() => onClick?.()}
      style={{ width: width ?? "auto" }}
    >
      {icon}
      <div className={style.text_wrapper}>
        <Font fontType="BODY">{title}</Font>
      </div>
    </div>
  );
};

export default TabWithIconPanel;
